export const gridContainer: any = {
  hidden: {},
  visible: {
    // was delayChildren: 0.38 — content grid items now start at 0.1s instead of 0.38s
    transition: { staggerChildren: 0.07, delayChildren: 0.1 },
  },
};

export const slideUp: any = {
  hidden: { opacity: 0, y: 36 },
  visible: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.52, ease: [0.22, 1, 0.36, 1] },
  },
};

// brightness(1) is set on "visible" so the filter compositor layer is
// established upfront. Without it, going from no-filter → brightness(1.1)
// on hover forces a new compositing context, causing the one-frame black flash
// in CEF (FiveM's transparent WebView background renders as black).
export const smallCardWrapper: any = {
  hidden: { opacity: 0, y: 36 },
  visible: {
    opacity: 1,
    y: 0,
    filter: "brightness(1)",
    transition: { duration: 0.52, ease: [0.22, 1, 0.36, 1] },
  },
  hover: {
    scale: 1.018,
    y: -5,
    filter: "brightness(1.1)",
    transition: { duration: 0.22, ease: "easeOut" },
  },
  tap: {
    scale: 0.966,
    y: 0,
    filter: "brightness(0.95)",
    transition: { duration: 0.1 },
  },
};

export const slideRight: any = {
  hidden: { opacity: 0, x: 48 },
  visible: {
    opacity: 1,
    x: 0,
    transition: { duration: 0.58, ease: [0.22, 1, 0.36, 1] },
  },
};
